export default function esPreguntaObligatoria(num) {
  return num === -1 ? "(Obligatorio)" : ""
}
